var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(
    _vm.disabled ? _vm.message || _vm.$t('AOIKUMO_READ_ONLY.TOOLTIP_MESSAGE') : ''
  ),expression:"\n    disabled ? message || $t('AOIKUMO_READ_ONLY.TOOLTIP_MESSAGE') : ''\n  "}]},[_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }